var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "4.141mm",
    height: "4.136mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 4.00314 3.99831",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.320673 0.162705c0.585177,0 1.17026,0 1.75543,0 0.0893282,0 0.162415,0.0730867 0.162415,0.162415l0 0c0,0.0893282 -0.0730867,0.162415 -0.162415,0.162415 -0.584307,0 -1.16842,-0.00135346 -1.75263,-0.00135346l0 3.18865 3.18865 0c0,-0.586144 -0.00135346,-1.17209 -0.00135346,-1.75824 0,-0.0893282 0.0730867,-0.162415 0.162415,-0.162415l0 0c0.0893282,0 0.162415,0.0730867 0.162415,0.162415 0,0.587014 0,1.17403 0,1.76104 0,0.176433 -0.14424,0.320673 -0.320673,0.320673l-3.19426 0c-0.176433,0 -0.320673,-0.14424 -0.320673,-0.320673l0 -3.19426c0,-0.176433 0.14424,-0.320673 0.320673,-0.320673zm2.69831 -0.0524948c0.131962,-0.133316 0.192868,-0.148204 0.326377,-0.0308395 0.18552,0.18436 0.370944,0.368624 0.556464,0.552984 0.170052,0.154197 0.109533,0.216843 -0.0601322,0.393373 -0.594845,0.595425 -1.18959,1.19085 -1.78444,1.78627 -0.0783072,0.0670928 -0.0971589,0.0661261 -0.209593,0.0686396 -0.176916,0 -0.353736,0 -0.530652,0 -0.133412,0.00280359 -0.201859,-0.0590688 -0.199248,-0.192288 0,-0.18668 0,-0.373264 0,-0.559945 0.00609056,-0.115334 0.0207852,-0.128095 0.161448,-0.267985 0.579957,-0.583437 1.15982,-1.16678 1.73977,-1.75021zm-0.0756969 0.534712l0.00425372 0.00154681 0.406907 0.410194 0.00270692 0.0051238 0.258704 -0.25822 -0.416865 -0.413578 -0.255707 0.254933zm0.194995 0.635352l-0.00377035 0.00135346 -0.413578 -0.413481 0.000193351 -0.00164348 -1.28056 1.27699 -0.00174016 0.418605 0.413578 0.00164348 1.28588 -1.28346z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4da51aacd673d35ba28796f6ad1cd30d.svg";
export { ForwardRef as ReactComponent };